module.exports = __webpack_public_path__ + "static/media/fuel-consumption-icon.efc41645.png";